var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip-container",class:{ wide: _vm.wide },style:({ color: _vm.chipColor, backgroundColor: _vm.bkColor })},[_c('p',{staticClass:"chip-title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }